<template>
  <div class="answers_choice">
    <div
      v-for="(item, i) in data"
      :key="i"
      class="answer"
      :class="{ 'has-other': item.type === 'other' && item.id === selected_id }"
    >
      <vcirclelabel
        :class="[
          'answer__check',
          {
            answer__check_other: item.type === 'other'
          }
        ]"
        :value="item.id === selected_id"
        :label="item.content"
        @input="set_selected_id(item)"
      />
      <vtextarea
        v-if="item.type === 'other' && item.id === selected_id"
        :value="other_val"
        :height="120"
        :placeholder="$tr('interview.tests.all.questions.answers.answer.value')"
        @input="set_input($event, item)"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'answers_choice',
    props: ['data', 'id'],
    data() {
      return {
        selected_id: null,
        other_val: null,
        other_check: false
      };
    },
    watch: {
      valid(v) {
        this.$emit('set_valid_date', v);
      }
    },

    computed: {
      valid() {
        if (!this.otherId || this.selected_id !== this.otherId) {
          return true;
        }

        return !!this.other_val;
      },
      otherId() {
        if (!this.data || !this.data.length) {
          return 0;
        }
        const otherItem = this.data.find(item => item.type === 'other');

        if (!otherItem) {
          return 0;
        }

        return otherItem.id;
      }
    },
    methods: {
      set_selected_id(v, skipSelected = false) {
        if (!skipSelected) {
          this.selected_id = v.id !== this.selected_id ? v.id : null;
        }

        let obj = {
          question_id: this.id
        };

        if (v.type !== 'other' && this.selected_id) {
          obj.answer_id = this.selected_id;
        }

        if (this.other_val && v.type === 'other') {
          obj.other = this.other_val;
          obj.answer_id = null;
        }

        this.$emit('update', obj);
      },

      set_input(v, item) {
        this.selected_id = item.id;
        this.other_val = v;
        this.set_selected_id(item, true);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .answers_choice {
    .answer {
      display: flex;
      margin-bottom: 8px;

      @media (max-width: 460px) {
        margin-bottom: 0;
      }

      &.has-other {
        flex-direction: column;
      }

      ::v-deep .vtextarea {
        margin-top: 8px;
        margin-left: 10px;
        margin-right: 4px;

        .textarea {
          padding: 13px 20px;
        }
      }

      ::v-deep .vcircle_label {
        padding: 0;

        &:hover {
          background-color: transparent;
        }

        .circle_label {
          font-size: 15px;
          line-height: 24px;
          letter-spacing: initial;
        }
      }
    }
    .answer__check {
      cursor: pointer;

      &_input {
        width: 100%;
        margin-top: 15px;
        margin-left: 10px;
      }

      &:hover {
        background-color: #f4f5f7;
      }
    }
  }
</style>
